const apiUrls = require('../../constants/apiUrls');

const repeatStatus = {
    key: 'repeatStatus',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_REPEATS_URL}?orderId=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }

            ]
        }
    ]
};



export default repeatStatus;


// WEBPACK FOOTER //
// ./src/store/order-details-config/repeatStatus.js